module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_6000_Inactive@1x-3d47921e2b0b17b736395db497a6bee6.png";